import React from 'react'
import { User } from 'stores/onboarding/types'

import { ArrowButton } from 'components/button/ButtonWithIcon'
import { H4 } from 'components/heading/Heading'
import { Svg } from 'components/svg/Svg'

import { useInnskraningOnMount } from 'hooks/onboarding/useInnskraningOnMount'
import { useOnMount } from 'hooks/useOnMount'
import { Properties } from 'types/onboarding'
import {
  InnskraningAnalyticsStepEnum,
  trackInnskraningEvent,
} from 'utils/onboarding/analytics'

import { StepHeader } from '../step-header/StepHeader'

import s from './Address.module.scss'

import { SelectPackage } from './SelectPackage'

export type Props = {
  user: User
  onSubmit: () => void
  transitionToAddNewAddress: () => void
  properties: Properties
  setProperties: (newProperties: Properties) => void
  offerType?: string | null
}

export const mapProductName = (productId: string) => {
  switch (productId) {
    case 'bilaorka':
      return 'BílaOrka'
    case 'hledsluorka':
      return 'HleðsluOrka'
    case 'naeturorka':
      return 'NæturOrka'
    case 'sparorka':
      return 'SparOrka'
    case 'graenorka':
      return 'GrænOrka'
    default:
      break
  }
}
export const Address = ({
  user,
  onSubmit,
  transitionToAddNewAddress,
  properties,
  setProperties,
  offerType,
}: Props) => {
  useInnskraningOnMount()

  useOnMount(() => {
    trackInnskraningEvent(InnskraningAnalyticsStepEnum.ADDRESS_PAGELOAD)
  })

  const text =
    properties.length === 1
      ? 'Eftirfarandi heimilisfang er skráð á þig. Þú getur bætt við öðrum heimilisföngum eða fjarlægt eftir hentisemi.'
      : 'Þú getur bætt við öðrum heimilisföngum eða fjarlægt eftir hentisemi.'

  return (
    <div className={s.address}>
      <StepHeader title={`Hæ ${user.name}`} />
      <>
        <StepHeader text={text} />

        <H4 as="h3" className={s.address__title}>
          {properties.length === 1
            ? 'Heimilisfang skráð á þig'
            : 'Heimilisföng'}
        </H4>

        <SelectPackage
          properties={properties}
          setProperties={setProperties}
          offerType={offerType}
        />

        <button
          className={s.address__addProperty}
          onClick={transitionToAddNewAddress}
        >
          <Svg id="plus" width={16} height={16} />
          Bæta við heimilisfangi
        </button>

        <ArrowButton onClick={onSubmit}>Halda áfram</ArrowButton>
      </>
    </div>
  )
}
